import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Heart, AlertCircle, Clock } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="w-full py-20 px-6 bg-navy text-white" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        {/* Who this is for */}
        <div className="grid md:grid-cols-2 gap-12 mb-20 border-b border-white/10 pb-16" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-149">
            <div className="flex items-center gap-3 mb-6" data-id="element-150">
              <Heart className="w-6 h-6 text-teal" data-id="element-151" />
              <h3 className="text-2xl font-bold text-white" data-id="element-152">
                You'll love this if:
              </h3>
            </div>
            <ul className="space-y-4 text-white/90" data-id="element-153">
              <li className="flex items-start gap-3" data-id="element-154">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2 flex-shrink-0" data-id="element-155" />
                <span data-id="element-156">You manage frequent appointments or urgent visits</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-157">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2 flex-shrink-0" data-id="element-158" />
                <span data-id="element-159">
                  You have a child with complex symptoms or an unclear diagnosis
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-160">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2 flex-shrink-0" data-id="element-161" />
                <span data-id="element-162">
                  You feel dismissed because the story is hard to tell quickly
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-163">
                <span className="w-1.5 h-1.5 rounded-full bg-teal mt-2 flex-shrink-0" data-id="element-164" />
                <span data-id="element-165">
                  You are exhausted and need a system that holds the details
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 p-6 rounded-xl border border-white/10" data-id="element-166">
            <div className="flex items-center gap-3 mb-6" data-id="element-167">
              <AlertCircle className="w-6 h-6 text-soft-sage" data-id="element-168" />
              <h3 className="text-2xl font-bold text-white" data-id="element-169">
                This is NOT for you if:
              </h3>
            </div>
            <ul className="space-y-4 text-white/80" data-id="element-170">
              <li className="flex items-start gap-3" data-id="element-171">
                <span className="w-1.5 h-1.5 rounded-full bg-soft-sage mt-2 flex-shrink-0" data-id="element-172" />
                <span data-id="element-173">
                  You want medical advice (this is a system, not a doctor)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-174">
                <span className="w-1.5 h-1.5 rounded-full bg-soft-sage mt-2 flex-shrink-0" data-id="element-175" />
                <span data-id="element-176">You want a decorative planner with stickers</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-177">
                <span className="w-1.5 h-1.5 rounded-full bg-soft-sage mt-2 flex-shrink-0" data-id="element-178" />
                <span data-id="element-179">
                  You refuse any weekly maintenance at all (even 15 minutes)
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* The Offer */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-12" data-id="element-181">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-182">
              The 24‑Hour Setup Promise
            </h2>
            <p className="text-lg text-white/80" data-id="element-183">
              You'll build the "minimum viable binder" first: Snapshot, Current
              meds, Allergies, Contacts, Post-visit sheet. That alone makes you
              ER-ready.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white text-navy p-8 md:p-12 rounded-2xl shadow-2xl relative overflow-hidden" data-id="element-184">
            <div className="absolute top-0 left-0 w-full h-2 bg-teal" data-id="element-185" />

            {/* Savings Badge */}
            <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-white uppercase bg-teal rounded-full animate-pulse" data-id="element-186">
              Save 63% — Limited Time Offer
            </span>

            <div className="flex items-center justify-center gap-2 mb-6 text-navy/70 text-sm font-medium" data-id="element-187">
              <Clock className="w-4 h-4" data-id="element-188" />
              <span data-id="element-189">Offer ends soon</span>
            </div>

            <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-190">
              <span className="text-2xl text-muted line-through font-medium" data-id="element-191">
                $17.00
              </span>
              <h3 className="text-5xl font-bold text-navy" data-id="element-192">$6.36</h3>
            </div>
            <p className="text-teal font-semibold text-sm mb-2" data-id="element-193">
              You save $10.64
            </p>
            <p className="text-muted font-medium mb-8" data-id="element-194">
              Complete ER‑Ready Mom Binder PDF Kit
            </p>

            <a href="https://www.betterbysteps.com/cart/44200151777373:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-8 py-4 bg-navy text-white text-lg font-bold rounded-full hover:bg-navy/90 transition-colors shadow-lg flex items-center justify-center mx-auto group" data-id="element-195">
              <span data-id="element-196">Download the Kit — $6.36</span>
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-197" />
            </a>

            <p className="mt-6 text-sm text-muted max-w-sm mx-auto" data-id="element-198">
              Because the point is not to give you another "project." The point
              is to give you relief fast.
            </p>
          </motion.div>

          {/* Risk Reversal */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-16 bg-white/5 border border-white/10 rounded-xl p-8 max-w-2xl mx-auto" data-id="element-199">
            <div className="flex flex-col items-center text-center" data-id="element-200">
              <div className="w-12 h-12 bg-teal/20 rounded-full flex items-center justify-center mb-4" data-id="element-201">
                <ShieldCheck className="w-6 h-6 text-teal" data-id="element-202" />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-203">
                The "Peace of Mind" Promise
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-204">
                If you download it and realize it doesn't fit your life, don't
                force it. Just email us within 30 days and we'll refund every
                penny. You should not have to "make a product work" when your
                kid is sick.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Final Close */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-24 text-center max-w-xl mx-auto border-t border-white/10 pt-12" data-id="element-205">
          <p className="text-xl md:text-2xl font-serif italic mb-8 leading-relaxed" data-id="element-206">
            "You can't control how fast the room moves. But you can control
            whether you walk in with scattered paper and hope, or with a
            one-page snapshot that tells the truth clearly."
          </p>
          <p className="text-teal font-bold tracking-widest uppercase text-sm" data-id="element-207">
            Build it in 24 hours. Use it for years.
          </p>
        </motion.div>
      </div>
    </section>;
}